import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {PermissionService} from "../../core/services/permission.service";

@Component({
    selector: 'admin-password',
    templateUrl: './admin-password.component.html',
    styleUrls: ['./admin-password.component.scss']
})

export class AdminPasswordComponent implements OnInit {

    adminPassword:string;

    adminPasswordConfirmation:string;

    state: any = {
        isSubmitted: false
    };

    @Output() onInit = new EventEmitter();

    @ViewChild('f', { static: true }) form;

    constructor(private permissionService: PermissionService) {

    }

    ngOnInit() {
        this.onInit.emit(this.form);
    }

    validate() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;
        this.permissionService.validateAdminPassword(this.adminPassword);
    }
}

